import React from "react";
import SelectMulti from "../../form/select/multi";

export default function EquipmentSelector({
  brand,
  handleAddEquipment,
  selectedEquipments,
}) {
  return (
    <SelectMulti
      id={brand?.id}
      onChange={handleAddEquipment}
      options={brand?.equipments?.map((model) => ({
        value: model.id,
        label: model.equipment_name,
      }))}
      value={selectedEquipments?.map((e) => ({
        value: e.id,
        label: e.equipment_name,
      }))}
      placeholder="Select models"
      trackChanges
      showSelectAll={false}
      selectedTextPrefix="Models: "
    />
  );
}
